import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(private http: HttpClient) { }


    register(name:string, email:string, web:string, address:string, phone:string, companyName:string, companyType:string, instagram:string): Observable<any> {
      return this.http.post(`${environment.apiUrl}companies`, { name, email, web, address, phone, companyName, companyType, instagram })
        .pipe(
          tap((response: any) => {
            // Puedes manejar el token aquí si tu API lo devuelve en el registro
            // localStorage.setItem('token', response.token);
          })
        );
    }
}
